import * as React from 'react';

import CircularProgress from '@material-ui/core/CircularProgress';

import MapFieldListInterface from '../../interfaces/MapFieldList';

import MapField from './MapField';

interface Props {
  mapFieldListOrder: number[];
  mapFieldListById: Record<number, MapFieldListInterface>;
  isError: boolean;
  isLoading: boolean;
  userId: string;
  setControlls: () => void;
}

const MapFieldList = ({
                        mapFieldListOrder,
                        mapFieldListById,
                        isError,
                        isLoading,
                        userId,
                        setControlls,
}: Props) => {

  return (
    <section className='map-list_wrap d-flex flex-column align-center'>
      <div className='map-list_info d-flex flex-column justify-center align-center'>
        <p>{`User auth_id: ${userId}`}</p>
        <button
          className='primary-button map-button'
          onClick={setControlls}>{'Show controls'}</button>
      </div>

      { !!isLoading && <CircularProgress /> }

      <div className='map-list'>
        {
          isError || isLoading || !mapFieldListOrder ?
            null :
            mapFieldListOrder.map((fieldId) => (
              <MapField
                key={mapFieldListById[fieldId].id}
                field={mapFieldListById[fieldId]} />
            ))
        }
      </div>
    </section>
  );
};

export default React.memo(MapFieldList);
